import { styled } from '@mui/material/styles';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router';
import ArrowRightIcon from '@/assets/nav-arrow-right.svg?react';

const Breadcrumbs = () => {
  return (
    <Root>
      <StyledLink to="/admin/partners">
        <FormattedMessage
          id="partnersAdmin"
          defaultMessage="Partners Admin"
        />
      </StyledLink>
      <ArrowRightIcon />
      <p>
        <FormattedMessage
          id="editPartner"
          defaultMessage="Edit Partner"
        />
      </p>
    </Root>
  );
};

const Root = styled('div')(({ theme }) => ({
  background: theme.palette.grey100,
  height: 88,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  padding: `0 40px`,
  fontWeight: 600,
  fontSize: 14,
  borderBottom: `1px solid ${theme.palette.grey200}`,

  p: {
    padding: theme.spacing(2),
  },
}));

const StyledLink = styled(Link)(({ theme }) => ({
  padding: theme.spacing(1),
  color: theme.palette.textGray,
  textDecoration: 'none',
}));

export default Breadcrumbs;
